module.exports = "/images/vendor/flag-icon-css/flags/4x3/gu.svg?2284e60e378b2304e722fd86e917d9f3";